var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94092 9.00023C1.94092 5.10376 5.10327 1.94141 8.99974 1.94141C12.8962 1.94141 16.0586 5.10376 16.0586 9.00023C16.0586 12.8967 12.8962 16.0591 8.99974 16.0591C5.10327 16.0591 1.94092 12.8967 1.94092 9.00023ZM8.48152 4.08556C10.0519 3.925 11.4802 4.50548 12.488 5.51206L12.8837 5.11067C13.2732 4.72162 13.9409 4.99951 13.9409 5.54912V7.76606C13.9409 8.10571 13.6627 8.3836 13.3226 8.3836H11.103C10.5528 8.3836 10.2807 7.71666 10.6702 7.32761L11.6038 6.39514C10.9361 5.72203 10.021 5.29593 8.99469 5.29593C6.68233 5.29593 4.85841 7.42024 5.37776 9.81628C5.66835 11.1872 6.77507 12.3049 8.14765 12.6075C9.97775 13.0151 11.6533 12.0641 12.3519 10.5635C12.4509 10.3597 12.6673 10.2362 12.896 10.2362C13.3536 10.2362 13.6503 10.7117 13.4525 11.1255C12.6611 12.7866 10.967 13.9414 8.99469 13.9414C6.07023 13.9414 3.75169 11.4157 4.09174 8.42065C4.34524 6.1543 6.21244 4.31405 8.48152 4.08556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.360926c23a66bf80a3b84ff36ed362af.svg";
export { ForwardRef as ReactComponent };